import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import store from '../../../stores/store';
let remote;
if (window.require) {
    remote = window.require('electron').remote;
}

class CloseAppModal extends React.Component {

    toggle = () => {
        store.user.hideCloseAppModal();
    };

    render() {
        return (
            <Modal className="modal-content" isOpen={this.props.show} autoFocus={false}>
                <ModalHeader toggle={this.toggle}>Sign out?</ModalHeader>
                <ModalBody>
                    <div className="card-group">
                        <div className="col p-0">
                            <p>
                                Signing out will remove downloaded content from this device.<br />
                            </p>
                            <button
                                type="button"
                                className="btn btn-block btn-outline-primary"
                                data-dismiss="modal"
                                onClick={() => store.user.logout()}
                            >
                                Sign out
                            </button>
                        </div>
                        <div className="or-divider text-muted" />
                        <div className="col p-0 rela-posi">
                            <p>Close application to save offline content and PIN.</p>
                            <button
                                type="button"
                                className="btn btn-block btn-primary abso-posi-stick-to-bottom"
                                onClick={
                                    window.offlineApiExtension
                                        ? () => remote.getCurrentWindow().close()
                                        : null
                                }
                            >
                                Close
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default CloseAppModal;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/CloseAppModal/CloseAppModal.js